/**
 * Sección Process del Panel People: los onboardings que siguen vivos (futuros,
 * en curso y con errores) con su pipeline por etapas, partidos en Esta semana /
 * Histórico. Solo ingresos desde PANEL_SINCE (07/09/2026); cuando todos los
 * pasos cierran, la fila pasa sola a Completed (usePeopleFlowRows).
 */

import { useTranslation } from 'react-i18next';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { WinclapLoader } from '@/components/ui/winclap-loader';
import { WeekSplitTable } from './WeekSplitTable';
import { usePeopleFlowRows } from './usePeopleFlowRows';

export function OnboardingProcessTab({ lastRunAt }: { lastRunAt: string | null }) {
  const { t } = useTranslation();
  const { rows, buckets, isLoading, error } = usePeopleFlowRows();

  if (isLoading) return <WinclapLoader />;
  if (error) {
    return (
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>{t('users.people_panel.load_error')}</AlertTitle>
        <AlertDescription>{error.message}</AlertDescription>
      </Alert>
    );
  }

  return (
    <WeekSplitTable rows={buckets.active} allRows={rows} emptyText={t('users.people_panel.empty')} lastRunAt={lastRunAt} />
  );
}
